/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect, useState } from 'react';
import mbpLogger from 'mbp-logger';
import getSiteConfig from '../../../../utils/getSiteConfig';
import { useMutation } from 'react-query';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    IconButton,
    CircularProgress,
    Button,
} from '@material-ui/core';

import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles';
import {
    shape, string, object, func, arrayOf, bool,
} from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { isEmpty } from '../../../../utils/object';
import { getSSRDeviceType } from '../../../../../../../state/ducks/App/App-Selectors';
import { getOperatingSystem } from '../../../../../../../state/ducks/App/ducks/Config/Config-Helpers';
import LinkOpenChat from '../../../../common/LinkOpenChat'
import customBreakpoints from '../../../../../../helpers/customBreakpoints';
import ReplacementOrderV2Screens from './ReplacementOrderV2Screens';
import ReplacementHelper from './ReplacementOrderV2Helper';
import { getFeatureFlags } from '../../../../../../../state/ducks/App/ducks/Config/Config-Selectors'
import triggerPopChatEvent from '../../../../../../components/MultiBrandChatController/AigoChatWidgetWrapperV2/popOpenChat';
import Helper from '../../../../../Account/state/reducers/Helper';
import fetchProductAvailability from '../../../../../../../apis/replacement-apis/fetchProductAvailability';
import processReplaceOrder from '../../../../../../../apis/replacement-apis/processReplaceOrder';
import processOrderRefund from '../../../../../../../apis/replacement-apis/processOrderRefund';
import processPartialRefund from '../../../../../../../apis/replacement-apis/processPartialRefund';
import { getAccessTokenSafely } from '../../../../../../../state/ducks/Member/ducks/Auth/Plugin/auth/auth';

const styles = (theme) => ({
    modalTitle: {
        fontSize: '20px',
        fontWeight: 'bold',
        textAlign: 'center',
    },
    modalTitleContainer: {
        backgroundColor: theme.palette.colorNeutral40,
        padding: 0,
        zIndex: 999,
    },
    modalBodyText: {
        padding: '5px 15px 5px 0',
        fontSize: '18px',
        color: 'black',
        marginBottom: '0px',
        fontWeight: '500',
        marginTop: '10px',
        [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
            fontSize: '16px',
            padding: '0px',
        },
    },
    modalBodyErrorText: {
        padding: '5px 15px 5px 15px',
        fontSize: '18px',
        color: 'black',
        marginBottom: '0px',
        fontWeight: '500',
        marginTop: '10px',
        [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
            fontSize: '16px',
        },
    },
    closeButton: {
        position: 'absolute',
        top: '5px',
        right: '10px',
        color: theme.palette.colorPrimaryAccountCtaButton,
    },
    buttonsWrapper: {
        margin: '10px auto',
        paddingBottom: '5px',
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
            margin: '15px 0',
            justifyContent: 'space-evenly',
        },
    },
    cancelButton: {
        padding: '10px 25px',
        margin: '0 10px',
        background: theme.palette.common.white,
        cursor: 'pointer',
        color: theme.palette.colorPrimaryAccountCtaButton,
        border: `1px solid ${theme.palette.colorPrimaryAccountCtaButton}`,
        width: '45%',
        fontSize: 14,
        fontWeight: '600',
        [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
            borderRadius: '50px',
            margin: 0,
            padding: '10px',
            fontSize: 12,
        },
        '&:hover': {
            opacity: '.90',
            backgroundColor: `${theme.palette.common.white} !important`,
        },
    },
    singleCancel: {
        width: '50%',
        [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
            width: '80%',
        },
    },
    CTAButton: {
        padding: '10px 25px',
        margin: '0 10px',
        background: theme.palette.colorPrimaryAccountCtaButton,
        color: theme.palette.common.white,
        border: 0,
        cursor: 'pointer',
        fontSize: 14,
        width: '45%',
        fontWeight: '600',
        '&:disabled': {
            backgroundColor: theme.palette.colorNeutral50,
            color: theme.palette.common.white,
        },
        '&:hover': {
            opacity: '.90',
            backgroundColor: `${theme.palette.colorPrimaryAccountCtaButton} !important`,
        },
        [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
            borderRadius: '50px',
            margin: 0,
            padding: '10px',
            fontSize: 12,
        },
    },
    singleCTA: {
        width: '50%',
        [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
            width: '80%',
        },
    },
    modalContentContainer: {
        minHeight: '400px',
        height: 'auto',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
            padding: '8px',
        },
    },
    modalInnerContent: {
        marginLeft: '20px',
        position: 'relative',
        marginTop: '10px',
        [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
            marginTop: '28px',
            marginLeft: '15px',
            marginRight: '15px',
        },
    },
    radioButtons: {
        fontSize: '18px',
    },
    radioButtonsPage1: {
        fontSize: '18px',
        '&:first-letter': {
            textTransform: 'capitalize',
        },
        [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
            fontSize: '16px',
        },
    },
    loaderContainer: {
        margin: 'auto',
    },
    errorIconWrap: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '4vh',
    },
    errorIcon: {
        width: '80.76px',
    },
    mobileLink: {
       color: 'inherit',
       textDecoration: 'none'
    }
});

const ReplacementOrderModal = ({ ROSSOrder,
    isPartialCreditEnabled, isReplacementEnabled, productType, ROSSOrderNumber, startTime, ssrDeviceType, handleChangeModalState, history, classes, featureFlags, ROSSOrderTotal, noDLCF }) => {

    const isQualityIssueChatFlowEnabled = featureFlags?.['is-quality-issue-chat-flow-enabled']; // This flag controls either Chat pop or normal flow for FPT Delivered damaged/broken/spoiled
    const isHDQualityIssueChatFlowEnabled = featureFlags?.['is-hd-quality-issue-chat-flow-enabled']; // This flag controls either Chat pop or normal flow for HD - Delivered damaged/broken/spoiled
    const isDeliveryIssueFlowEnabled = featureFlags?.['is-delivery-issue-flow-enabled'];
    const isAvailabilityCheckByPassEnabled = featureFlags?.['is-availability-check-bypass-enabled'];
    const isHDReplacementRoutingToAgent = featureFlags?.['is-hd-replacement-routing-to-agent'];

    const [isAvailable, setIsAvailable] = useState(null);
    const [availabilityError, setAvailabilityError] = useState('');
    const [replaceResponse, setReplaceResponse] = useState({});
    const [replaceResponseError, setReplaceResponseError] = useState('');
    const [refundResponse, setRefundResponse] = useState({});
    const [refundResponseError, setRefundResponseError] = useState('');
    const [partialRefundResponse, setPartialRefundResponse] = useState({});
    const [partialRefundResponseError, setPartialRefundResponseError] = useState('');
    const [componentState, setComponentState] = useState({ 
        page0: false,
        page1: false,
        page2: false,
        page3: false,
        page4: false,
        page5: false,
        page6: false,
        page7: false,
        customerService: false,
        condition: '',
        error: '',
        issueResolution: '', // replacement, 50% refund + $15 savings pass
        issueReasonType: '', // Quality Issue' or 'Delivered Wrong' or 'Delivery Issue'
        issueProductType: '', // floral, container, food
        issueProductCondition: '', // broken, torn, expired, etc
        shippingBoxDamaged: false,
        isLoading: true,
        page0ReasonType: '',
        page1ReasonType: '',
        page2ReasonType: '',
        page3ReasonType: '',
        page4ReasonType: '',
        page5ReasonType: '',
        page6ReasonType: '',
        page7ReasonType: '',
        showFallbackScreen: false,
        event: {},
        currentPage: '',
        nextPage: '',
    });

    const { page0, page1, page2, page3, page4, page5, page6, page7, page0ReasonType, page1ReasonType, page2ReasonType, page3ReasonType, page4ReasonType, page5ReasonType, page7ReasonType, error, isLoading, showFallbackScreen, currentPage, nextPage } = componentState;
    const productBrand = ROSSOrder.items[0].productBrand;
    const siteConfig = getSiteConfig();
    const deviceType = ssrDeviceType;
    const user = Helper.getChannelUser(deviceType, siteConfig.domain, featureFlags['is-web-using-new-channel-codes']);
    const isFoodBrand = Helper.isFoodBrand(productBrand);
    const operatingSystem = getOperatingSystem().toLowerCase();
    const abcGbmChatPayload = { 
     intent: 'report_an_issue', 
     orderNumber: ROSSOrderNumber, 
     message: `${page0ReasonType} | ${page1ReasonType} | ${page2ReasonType} | ${page3ReasonType === 'sounds great. Let\'s do it.' ? 're-delivery' : `${page3ReasonType}`} | ${page4ReasonType} | ${page5ReasonType}`
    };
    const isShowingMobileChatLink = (operatingSystem === 'ios' || operatingSystem === 'android');

    const fetchProductAvailabilityMutation = useMutation({
      mutationFn: fetchProductAvailability,
      onSuccess: (data) => {
         if (data && data.data !== undefined) {
            setIsAvailable(data.data);
         }
      },
      onError: (error) => {
         setAvailabilityError('Error Fetching Product Availability');
         mbpLogger.logError({
             function: 'fetchProductAvailabilityMutation',
             appName: process.env.npm_package_name,
             module: 'ReplacementOrderV2Modal',
             message: 'Error Fetching Product Availability',
             error,
         });
      }
    });

    const processReplaceOrderMutation = useMutation({
      mutationFn: processReplaceOrder,
      onSuccess: (data) => {
         if (data && data.data !== undefined) {
            setReplaceResponse(data.data);
         }
      },
      onError: (error) => {
         setReplaceResponseError('Error while processing replacement');
         mbpLogger.logError({
             function: 'processReplaceOrderMutation',
             appName: process.env.npm_package_name,
             module: 'ReplacementOrderV2Modal',
             message: `Error While Processing Replacement for Order# ${ROSSOrderNumber}`,
             error,
         });
      }
    });

    const processOrderRefundMutation = useMutation({
      mutationFn: processOrderRefund,
      onSuccess: (data) => {
         if (data && data.data !== undefined) {
            setRefundResponse(data.data);
         }
      },
      onError: (error) => {
         setRefundResponseError('Error while processing a refund');
         mbpLogger.logError({
             function: 'processOrderRefundMutation',
             appName: process.env.npm_package_name,
             module: 'ReplacementOrderV2Modal',
             message: `Error While Processing a Refund for Order# ${ROSSOrderNumber}`,
             error,
         });
      }
    });

    const processPartialRefundMutation = useMutation({
      mutationFn: processPartialRefund,
      onSuccess: (data) => {
         if (data && data.data !== undefined) {
            setPartialRefundResponse(data.data);
         }
      },
      onError: (error) => {
         setPartialRefundResponseError('Error while processing a partial refund');
         mbpLogger.logError({
             function: 'processPartialRefundMutation',
             appName: process.env.npm_package_name,
             module: 'ReplacementOrderV2Modal',
             message: `Error While Processing a Partial Refund for Order# ${ROSSOrderNumber}`,
             error,
         });
      }
    });
    

    const replaceOrder = async (payload) => {
      const jwtToken = await getAccessTokenSafely();
      processReplaceOrderMutation.mutate({
         requestBody: payload,
         jwtToken
      });
    };

    const refundOrder = async (payload) => {
      const jwtToken = await getAccessTokenSafely();
      processOrderRefundMutation.mutate({
         requestBody: payload,
         jwtToken
      });
    };

    const partialRefund = async (payload) => {
      const jwtToken = await getAccessTokenSafely();
      processPartialRefundMutation.mutate({
         requestBody: payload,
         jwtToken
      });
    };

    useEffect(() => {
        // fall back to error page if anything goes wrong
        const isFallBackRequired = checkIsRequiredFallBackScreen();
        if (!isFallBackRequired && (replaceResponse?.replaceOrder === true || partialRefundResponse?.message === 'Valid Message' || refundResponse?.refundOrder === true)) {
            setComponentState({
                ...componentState,
                [currentPage]: false,
                [nextPage]: true,
                isLoading: false,
            });
        };
    }, [replaceResponse, replaceResponseError, refundResponse, refundResponseError, partialRefundResponse, partialRefundResponseError]);

    useEffect(() => {
         const payload = {
            zipCode: ROSSOrder.recipientProfiles[0].addressDetail[0].zipCode,
            state: ROSSOrder.recipientProfiles[0].addressDetail[0].state,
            productSku: ROSSOrder.items[0].productSku,
            locationType: ROSSOrder.recipientProfiles[0].addressDetail[0].addressType,
            brandCode: productBrand,
            promCode: '',
         };

         const callProductAvailability = async () => {
            const jwtToken = await getAccessTokenSafely();
            fetchProductAvailabilityMutation.mutate({
               requestBody: payload,
               jwtToken,
            });
         };

         if (!isAvailabilityCheckByPassEnabled && isAvailable === null) { // do not check availability when we already have redux data available
            callProductAvailability();
         };
    }, []);

    useEffect(() => {
        // handle accidental close of modal before submit
        if (isAvailable === true || isAvailable === false || isAvailabilityCheckByPassEnabled) {
            setComponentState({
                ...componentState,
                isLoading: false,
                page0: true,
            })
        }

        if (availabilityError) {
            setComponentState({
                ...componentState,
                isLoading: false,
                error: 'generic',
                showFallbackScreen: true,
            })
        }
    }, [isAvailable, availabilityError]);

    const getCurrentPage = (currentPage, nextPage) => {
        setComponentState({
            ...componentState,
            currentPage,
            nextPage,
        });
    }

    const renderList = () => {
        if (!isDeliveryIssueFlowEnabled) {
            return ReplacementHelper.list1.slice(1);
        } else if (noDLCF) {
            return ReplacementHelper.noDLCFList;
        } else {
            return ReplacementHelper.list1
        }
    }

    const handleClickProceed = (currentPage, nextPage, stateToClear) => {
        setComponentState({
            ...componentState,
            [currentPage]: false,
            [nextPage]: true,
            [stateToClear]: '',
        });
    }
 
    const handleClickBack = (currentPage, previousPage, stateToClear) => {
        setComponentState({
            ...componentState,
            [currentPage]: false,
            [previousPage]: true,
            [stateToClear]: '',
        });
    }

    const handleSelectValue = (event) => {
        const selectedValue = event.target.value.split(':'); // ex: 'issueProductType:floral' => ['issueProductType', 'floral']
        const stateType = selectedValue[0]; // ex: 'issueProductType'
        const value = selectedValue[1]; // ex: 'floral'

        setComponentState({
            ...componentState,
            [stateType]: value,
        })
    }

    const checkIsRequiredFallBackScreen = () => {
        let fallBackRequired = false;
        let errorMsg = '';
        let isLoading = true;

        if ((!isEmpty(replaceResponse) && replaceResponse?.replaceOrder !== true) 
            || (!isEmpty(replaceResponseError) && replaceResponseError !== '')
            || (!isEmpty(partialRefundResponse) && partialRefundResponse?.message && partialRefundResponse?.message !== 'Valid Message')
            || (!isEmpty(partialRefundResponseError) && partialRefundResponseError?.response?.data?.message !== '')
            || (!isEmpty(refundResponse) && refundResponse?.refundOrder !== true)
            || (!isEmpty(refundResponseError) && refundResponseError !== '')
            || error !== ''
           ) {

            fallBackRequired = true;
            isLoading = false;
            if ((replaceResponse?.message && replaceResponse?.message !== '') || (replaceResponseError && replaceResponseError !== '')) { 
                errorMsg = 'We are not able to automatically process your request right now. For immediate assistance, please chat with agent.';
            } else if ((refundResponse?.message && refundResponse?.message !== '') || (refundResponseError && refundResponseError !== '')) {
                errorMsg = 'We are not able to automatically process your request right now. For immediate assistance, please chat with agent.';
            } else if ((partialRefundResponse?.message && partialRefundResponse?.message !== '') || (partialRefundResponseError?.response?.data?.message && partialRefundResponseError?.response?.data?.message !== '')) {
                errorMsg = 'We are not able to automatically process your request right now. For immediate assistance, please chat with agent.';
            }
        };

        setComponentState({
            ...componentState,
            showFallbackScreen: fallBackRequired,
            error: errorMsg,
            isLoading,
        })

        return fallBackRequired;
    }

    const handleReplaceOrder = async (payload, currentPage) => {

        setComponentState({
            ...componentState,
            isLoading: true,
            [currentPage]: false,
        });

        if (!isAvailabilityCheckByPassEnabled) {
            if (isAvailable) {
                await replaceOrder(payload);
            }
        } else {
            await replaceOrder(payload);
        }
    }

    const handlePartialRefundOrder = async (payload, currentPage) => {
        setComponentState({
            ...componentState,
            isLoading: true,
            [currentPage]: false,
        });

        await partialRefund(payload)
    }

    const handleRefundOrder = async (payload, currentPage) => {
        setComponentState({
            ...componentState,
            isLoading: true,
            [currentPage]: false,
        });
        
        await refundOrder(payload);
    }

    const handleOpenChat = (fallbackScreen) => {
        const { shippingCharge, serviceCharge } = ROSSOrder.billingProfile;
        const isDeliveredLate = isFoodBrand && page0ReasonType === 'delivered late';
        const isPaidShpping = (shippingCharge !== '' && shippingCharge !== '0') || (serviceCharge !== '' && serviceCharge !== '0');
        const isChatRadioSelected = 
        ((isHDReplacementRoutingToAgent && page3ReasonType !== '' && page3ReasonType === 'sounds great. Let\'s do it.') // We don't need to check for food brand here because already do so in renderButtonText for this scenario
        || (isHDReplacementRoutingToAgent && page3ReasonType !== '' && page3ReasonType === 'Yes, more than 50%.' && page4ReasonType !== '' && page4ReasonType === 'sounds great. Let\'s do it.')
        || (isQualityIssueChatFlowEnabled && page0ReasonType !== '' && page0ReasonType?.toLowerCase().includes('delivered damaged') && Helper.isFloralBrand(productBrand)))
        || (isHDQualityIssueChatFlowEnabled && page0ReasonType !== '' && page0ReasonType?.toLowerCase().includes('delivered damaged') && Helper.isFoodBrand (productBrand))
        || (page0ReasonType !== '' && page0ReasonType === 'delivered too early' && page3ReasonType !== '' && page3ReasonType === 'sounds great. Let\'s do it.') // HD delivered early replacement - pops chat
        || (page0ReasonType !== '' && page0ReasonType === 'i need additional help.') // no DLCF Chat Option
        || (page2ReasonType !== '' && page2ReasonType?.toLowerCase().includes('chat'))
        || (page3ReasonType !== '' && page3ReasonType?.toLowerCase().includes('chat')) 
        || (page4ReasonType !== '' && page4ReasonType?.toLowerCase().includes('chat')) 
        || (page4ReasonType !== '' && page4ReasonType === 'redeliver the item for the requested date') // HD delivered early full refund - pops chat
        || (page3ReasonType !== '' && page3ReasonType === 'No, less than 50%.' && page4ReasonType !== '' && page4ReasonType === 'sounds great. Let\'s do it.')
        || (page3ReasonType !== '' && page3ReasonType === 'No, less than 50%.' && page5ReasonType !== '' && page5ReasonType === 'issue a full refund.')
        || (page3ReasonType !== '' && isDeliveredLate && page3ReasonType === 'sounds great. Let\'s do it.')
        || (page5ReasonType !== '' && page5ReasonType?.toLowerCase().includes('chat'))
        || ((page0ReasonType !== '' && (page0ReasonType === 'doesn\'t look like picture' || page0ReasonType === 'wrong item delivered' )
        && page1ReasonType !== '' && page1ReasonType === 'food (chocolate, fruit, cheese)')
        && page2ReasonType !== '' && (page2ReasonType === 'missing item' || page2ReasonType === 'wrong item')
        && page3ReasonType !== '' && page3ReasonType === 'i need additional help.'
        && page4ReasonType !== '' && page4ReasonType === 'issue a 50% refund, and a $15 Savings Pass credit.')
        
        const reasonTypes = { page0ReasonType, page1ReasonType, page2ReasonType, page3ReasonType, page4ReasonType, page5ReasonType };
        const message = ReplacementHelper.generateAgentMessage(isChatRadioSelected, reasonTypes);
        const popChatPayload = { 
           origin: 'report an issue', 
           orderNumber: ROSSOrderNumber, 
           message
        };

        if (isDeliveredLate && isPaidShpping) {
         popChatPayload.shippingCharge = shippingCharge;
         popChatPayload.serviceCharge = serviceCharge;
        }

        if (isChatRadioSelected || fallbackScreen) {
            setComponentState({
               ...componentState,
               error: '',
               nextPage: '',
               showFallbackScreen: false,
            })
            triggerPopChatEvent(popChatPayload);
            handleChangeModalState('replacement', 'closeWindow', true);
        }
    }

    const handleSubmit = (currentPage) => {
        const deliveryDate = ROSSOrder.history.find((histObj) => histObj.codeStatus === 'DL')?.createdDate?.substring(0, 10) || '';
        const fallbackDeliveryDate = ROSSOrder.items[0].deliveryDate?.substring(0, 10) || '';
        const isMoreThan7Days = ReplacementHelper.checkIsMoreThan7Days(deliveryDate || fallbackDeliveryDate);
        const tiEmail = ROSSOrder?.billingProfile?.emailAddress;
        const isItemDLC = ROSSOrder?.status === 'DELIVERED';
        const isFoodBrand = Helper.isFoodBrand(productBrand);
        const resolutionBrand = !isFoodBrand && Helper.generateFloralResolutionBrand(productBrand)
        const { resolution, reason, item, condition, shippingBoxDamaged  } = ReplacementHelper.handleResolutionSelection(page0ReasonType, page1ReasonType, page2ReasonType, page3ReasonType, page4ReasonType, page5ReasonType);
        setComponentState({...componentState, issueResolution: resolution, issueReasonType: reason, shippingBoxDamaged, issueProductType: item, issueProductCondition: condition });

        if (resolution !== '' && productType && reason !== ''){
            const resCode = isFoodBrand ? 0 : ReplacementHelper.handleResCode(isMoreThan7Days, productType, reason, shippingBoxDamaged, item, condition, isItemDLC);
            const floralPayload = !isFoodBrand && ReplacementHelper.generateResCodePayload(resCode, resolution, ROSSOrderNumber, productType, tiEmail, startTime, ssrDeviceType, resolutionBrand, noDLCF, user);
            const foodReplacementPayload = { orderNumber: ROSSOrderNumber, ti_email: tiEmail, brandCode: productBrand, user };
            const foodRefundPayload = { orderNumber: ROSSOrderNumber, user };
            if (isFoodBrand && resolution === 'refund') { // food brand refund
                handleRefundOrder(foodRefundPayload, currentPage);
            } else if (isFoodBrand && resolution === 'replacement' && resCode === 0) { // food brand replacement
                handleReplaceOrder(foodReplacementPayload, currentPage);
            } else if (resCode && resCode !== 0) {
                if (resolution === 'replacement') { // floral brand replacement
                    handleReplaceOrder(floralPayload, currentPage);
                } else if (resolution === 'partialRefund') { // floral brand partial refund
                    handlePartialRefundOrder(floralPayload, currentPage)
                }
            } else { // flows which has resCode = 0 show fall back screen
                if (resolution === 'replacement') {
                    setComponentState({
                        ...componentState,
                        showFallbackScreen: true,
                        error: 'Please chat with a live agent to complete your replacement request.',
                    });
                } else if (resolution === 'refund') {
                    setComponentState({
                        ...componentState,
                        showFallbackScreen: true,
                        error: 'Please chat with a live agent to complete your refund request.',
                    });
                } else if (resolution === 'partialRefund') {
                  setComponentState({
                      ...componentState,
                      showFallbackScreen: true,
                      error: 'Please chat with a live agent to complete your partial refund request.',
                  });
               }
            }
        };
    }

    const renderHeaderComponent = () => {
        return (
            <>
                <DialogTitle className={classes.modalTitleContainer}>
                    <IconButton
                        aria-label="close-modal"
                        className={classes.closeButton}
                        size="small"
                        onClick={() => {
                            // if replace / refund service is called, force refresh so ROSS Order fields can update
                            if (!isEmpty(replaceResponse) || !isEmpty(replaceResponseError) || !isEmpty(refundResponse) || !isEmpty(partialRefundResponse) || !isEmpty(partialRefundResponseError) || error !== '') {
                                history.go();
                            } else {
                                handleChangeModalState('replacement', 'closeWindow', true);
                            }
                        }}
                        edge="end"
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
            </>
        );
    }
 
    const renderFallbackUI = () => {
        let errorMessage = '';
        const hasErrorState = error?.length > 0;
        
        if (error.includes('Please chat with a live agent')) {
            errorMessage = (
               <>
                   <div className={classes.modalBodyErrorText}>{error}</div>
               </>
            );
         } else {
            errorMessage = (
                <>
                    <div className={classes.modalBodyErrorText}>We are not able to automatically process your request right now.</div>
                    <div className={classes.modalBodyErrorText}>For immediate assistance, please chat with agent.</div>
                </>
            );
        }

        return (
            <DialogContent className={classes.modalContentContainer}>
                <DialogContentText>
                    <p className={classes.modalBodyText}>{errorMessage}</p>
                </DialogContentText>
                <div className={classes.buttonsWrapper}>
                    {error !== ''
                        ? (
                            <Button
                                className={classes.CTAButton}
                                type="button"
                                onClick={isShowingMobileChatLink ? () => {} : () => handleOpenChat(true)} // handleOpenChat handles Desktop pop chat
                                onKeyDown={() => {}}
                                >
                                {isShowingMobileChatLink ? <LinkOpenChat customClass={classes.mobileLink} userData={abcGbmChatPayload}>Chat with agent</LinkOpenChat> : "Chat with agent"}
                            </Button>
                        )
                        : (
                            <Button
                                className={classes.CTAButton}
                                type="button"
                                onClick={() => {
                                    // if replace, savings pass service is called, force refresh so ROSS Order fields can update
                                    if ((!isEmpty(replaceResponse) || hasErrorState) || !isEmpty(replaceResponseError) || isAvailable === false || refundResponseError || !isEmpty(partialRefundResponseError)) {
                                        history.go();
                                    } else handleChangeModalState('replacement', 'closeWindow');
                                }}
                                onKeyDown={() => {}}
                            >
                                Close Window
                            </Button>
                        )
                    }
                    
                </div>
            </DialogContent>
        );
    }

    const renderPage0 = () => {
        let pageData = {};
        if (isFoodBrand) {
            pageData = ReplacementHelper.getFoodBrandPageDetails('page0', { page0ReasonType, isHDQualityIssueChatFlowEnabled, productBrand });
        } else {
            pageData = ReplacementHelper.getPageDetails('page0', { page0ReasonType }, null, null, null, null, null, isQualityIssueChatFlowEnabled, productBrand);
        }
        const { text1, nextPage, btnType } = pageData;
        return <ReplacementOrderV2Screens
            classes={classes}
            reloadPage={() => history.go()}
            radioList={renderList()}
            text1={text1}
            handleSelectValue={handleSelectValue}
            handleClickProceed={handleClickProceed}
            handleClickBack={handleClickBack}
            currentPage="page0"
            nextPage={nextPage}
            btnType={btnType}
            currentSelectedRadio={page0ReasonType}
            handleOpenChat={handleOpenChat}
            isLoading={isLoading}
            handleChangeModalState={handleChangeModalState}
            refundResponse={refundResponse}
            replaceResponse={replaceResponse}
            partialRefundResponse={partialRefundResponse}
            getCurrentPage={getCurrentPage}
            ROSSOrderNumber={ROSSOrderNumber}
            page0ReasonType={page0ReasonType}
            page1ReasonType={page1ReasonType}
            page2ReasonType={page2ReasonType}
            page3ReasonType={page3ReasonType}
            page4ReasonType={page4ReasonType}
            page5ReasonType={page5ReasonType}
            operatingSystem={operatingSystem}
            abcGbmChatPayload={abcGbmChatPayload}
            isShowingMobileChatLink={isShowingMobileChatLink}
        />
    }

    const renderPage1 = () => {
        let pageData = {};
        if (isFoodBrand) {
            pageData = ReplacementHelper.getFoodBrandPageDetails('page1', { page0ReasonType });
        } else {
            pageData = ReplacementHelper.getPageDetails('page1', { page0ReasonType });
        }
        const { text1, nextPage, screenListType, previousPage } = pageData;
        return <ReplacementOrderV2Screens
            classes={classes}
            reloadPage={() => history.go()}
            radioList={screenListType}
            text1={text1}
            handleSelectValue={handleSelectValue}
            handleClickProceed={handleClickProceed}
            handleClickBack={handleClickBack}
            currentPage="page1"
            nextPage={nextPage}
            previousPage={previousPage || "page0"}
            currentSelectedRadio={page1ReasonType}
            handleOpenChat={handleOpenChat}
            isLoading={isLoading}
            handleChangeModalState={handleChangeModalState}
            refundResponse={refundResponse}
            replaceResponse={replaceResponse}
            partialRefundResponse={partialRefundResponse}
            getCurrentPage={getCurrentPage}
            ROSSOrderNumber={ROSSOrderNumber}
            page0ReasonType={page0ReasonType}
            page1ReasonType={page1ReasonType}
            page2ReasonType={page2ReasonType}
            page3ReasonType={page3ReasonType}
            page4ReasonType={page4ReasonType}
            page5ReasonType={page5ReasonType}
            operatingSystem={operatingSystem}
            abcGbmChatPayload={abcGbmChatPayload}
            isShowingMobileChatLink={isShowingMobileChatLink}
        />
    }

    const renderPage2 = () => {
        let pageData = {};
        if (isFoodBrand) {
            pageData = ReplacementHelper.getFoodBrandPageDetails('page2', { page0ReasonType, page1ReasonType }, productType, isAvailable);
        } else {
            pageData = ReplacementHelper.getPageDetails('page2', { page0ReasonType, page1ReasonType }, productType, isAvailable);
        }
        const { text1, text2, text3, screenListType, btnType } = pageData;

        return <ReplacementOrderV2Screens
            classes={classes}
            reloadPage={() => history.go()}
            radioList={screenListType}
            text1={text1}
            text2={text2}
            text3={text3}
            handleSelectValue={handleSelectValue}
            handleClickProceed={handleClickProceed}
            handleClickBack={handleClickBack}
            currentPage="page2"
            nextPage="page3"
            previousPage="page1"
            btnType={btnType}
            handleSubmit={handleSubmit}
            currentSelectedRadio={page2ReasonType}
            handleOpenChat={handleOpenChat}
            isLoading={isLoading}
            handleChangeModalState={handleChangeModalState}
            refundResponse={refundResponse}
            replaceResponse={replaceResponse}
            partialRefundResponse={partialRefundResponse}
            getCurrentPage={getCurrentPage}
            ROSSOrderNumber={ROSSOrderNumber}
            page0ReasonType={page0ReasonType}
            page1ReasonType={page1ReasonType}
            page2ReasonType={page2ReasonType}
            page3ReasonType={page3ReasonType}
            page4ReasonType={page4ReasonType}
            page5ReasonType={page5ReasonType}
            operatingSystem={operatingSystem}
            abcGbmChatPayload={abcGbmChatPayload}
            isShowingMobileChatLink={isShowingMobileChatLink}
        />
    }

    const renderPage3 = () => {
        let pageData = {};
        if (isFoodBrand) {
            const { shippingCharge, serviceCharge } = ROSSOrder?.billingProfile;
            const isPaidShpping = (shippingCharge !== '' && shippingCharge !== '0') || (serviceCharge !== '' && serviceCharge !== '0');
            pageData = ReplacementHelper.getFoodBrandPageDetails('page3', { page0ReasonType, page1ReasonType, page2ReasonType, page3ReasonType, productBrand, isHDReplacementRoutingToAgent }, productType, isAvailable, isReplacementEnabled, isPartialCreditEnabled, null, isPaidShpping);
        } else {
            pageData = ReplacementHelper.getPageDetails('page3', { page0ReasonType, page2ReasonType, page3ReasonType, noDLCF }, productType, isAvailable, isReplacementEnabled, isPartialCreditEnabled, null, null, null, ROSSOrder);
        }
        const { text1, text2, text3, previousPage, btnType, screenListType } = pageData;

        return <ReplacementOrderV2Screens
            classes={classes}
            reloadPage={() => history.go()}
            radioList={screenListType}
            text1={text1}
            text2={text2}
            text3={text3}
            handleSelectValue={handleSelectValue}
            handleClickProceed={handleClickProceed}
            handleClickBack={handleClickBack}
            currentPage="page3"
            nextPage="page4"
            previousPage={previousPage}
            btnType={btnType}
            handleSubmit={handleSubmit}
            currentSelectedRadio={page3ReasonType}
            handleOpenChat={handleOpenChat}
            isLoading={isLoading}
            handleChangeModalState={handleChangeModalState}
            refundResponse={refundResponse}
            replaceResponse={replaceResponse}
            partialRefundResponse={partialRefundResponse}
            getCurrentPage={getCurrentPage}
            ROSSOrderNumber={ROSSOrderNumber}
            page0ReasonType={page0ReasonType}
            page1ReasonType={page1ReasonType}
            page2ReasonType={page2ReasonType}
            page3ReasonType={page3ReasonType}
            page4ReasonType={page4ReasonType}
            page5ReasonType={page5ReasonType}
            operatingSystem={operatingSystem}
            abcGbmChatPayload={abcGbmChatPayload}
            isShowingMobileChatLink={isShowingMobileChatLink}
        />
    }

    const renderPage4 = () => {
        let pageData = {};
        if (isFoodBrand) {
            pageData = ReplacementHelper.getFoodBrandPageDetails('page4', { page0ReasonType, page1ReasonType, page2ReasonType, page3ReasonType, page4ReasonType, productBrand, isHDReplacementRoutingToAgent }, productType, isAvailable, isReplacementEnabled, isPartialCreditEnabled);
        } else {
            pageData = ReplacementHelper.getPageDetails('page4', { page0ReasonType, page1ReasonType, page2ReasonType, page3ReasonType, page4ReasonType }, productType, isAvailable, isReplacementEnabled, isPartialCreditEnabled);
        }
        const { text1, text2, text3, screenListType, btnType } = pageData;

        return <ReplacementOrderV2Screens
            classes={classes}
            reloadPage={() => history.go()}
            radioList={screenListType}
            text1={text1}
            text2={text2}
            text3={text3}
            handleSelectValue={handleSelectValue}
            handleClickProceed={handleClickProceed}
            handleClickBack={handleClickBack}
            currentPage="page4"
            nextPage="page5"
            previousPage="page3"
            btnType={btnType}
            handleSubmit={handleSubmit}
            currentSelectedRadio={page4ReasonType}
            handleOpenChat={handleOpenChat}
            isLoading={isLoading}
            handleChangeModalState={handleChangeModalState}
            refundResponse={refundResponse}
            replaceResponse={replaceResponse}
            partialRefundResponse={partialRefundResponse}
            getCurrentPage={getCurrentPage}
            ROSSOrderNumber={ROSSOrderNumber}
            page0ReasonType={page0ReasonType}
            page1ReasonType={page1ReasonType}
            page2ReasonType={page2ReasonType}
            page3ReasonType={page3ReasonType}
            page4ReasonType={page4ReasonType}
            page5ReasonType={page5ReasonType}
            operatingSystem={operatingSystem}
            abcGbmChatPayload={abcGbmChatPayload}
            isShowingMobileChatLink={isShowingMobileChatLink}
        />
    }

    const renderPage5 = () => {
        let pageData = {};
        if (isFoodBrand) {
            pageData = ReplacementHelper.getFoodBrandPageDetails('page5', { page0ReasonType, page1ReasonType, page2ReasonType, page3ReasonType, page4ReasonType, page5ReasonType }, null, isAvailable, null, null, ROSSOrderTotal);
        } else {
            pageData = ReplacementHelper.getPageDetails('page5', { page0ReasonType, page1ReasonType, page2ReasonType, page3ReasonType, page4ReasonType, page5ReasonType }, null, isAvailable, null, null, ROSSOrderTotal);
        }
        const { text1, text2, screenListType, btnType } = pageData;
        return <ReplacementOrderV2Screens
            classes={classes}
            reloadPage={() => history.go()}
            radioList={screenListType}
            text1={text1}
            text2={text2}
            handleSelectValue={handleSelectValue}
            handleClickProceed={handleClickProceed}
            handleClickBack={handleClickBack}
            currentPage="page5"
            nextPage='page6'
            previousPage='page4'
            btnType={btnType}
            handleSubmit={handleSubmit}
            currentSelectedRadio={page5ReasonType}
            handleOpenChat={handleOpenChat}
            isLoading={isLoading}
            handleChangeModalState={handleChangeModalState}
            refundResponse={refundResponse}
            replaceResponse={replaceResponse}
            partialRefundResponse={partialRefundResponse}
            getCurrentPage={getCurrentPage}
            ROSSOrderNumber={ROSSOrderNumber}
            page0ReasonType={page0ReasonType}
            page1ReasonType={page1ReasonType}
            page2ReasonType={page2ReasonType}
            page3ReasonType={page3ReasonType}
            page4ReasonType={page4ReasonType}
            page5ReasonType={page5ReasonType}
            operatingSystem={operatingSystem}
            abcGbmChatPayload={abcGbmChatPayload}
            isShowingMobileChatLink={isShowingMobileChatLink}
        />
    }

    const renderPage6 = () => {
        let pageData = {};
        if (isFoodBrand) {
            pageData = ReplacementHelper.getFoodBrandPageDetails('page6', { page5ReasonType }, null, null, null, null, ROSSOrderTotal);
        } else {
            pageData = ReplacementHelper.getPageDetails('page6', { page5ReasonType }, null, null, null, null, ROSSOrderTotal);
        }
        const { text1, text2 } = pageData;

        return <ReplacementOrderV2Screens
            classes={classes}
            reloadPage={() => history.go()}
            text1={text1}
            text2={text2}
            handleSelectValue={handleSelectValue}
            handleClickProceed={handleClickProceed}
            handleClickBack={handleClickBack}
            currentPage="page6"
            nextPage=''
            previousPage="page5"
            btnType="Close"
            handleOpenChat={handleOpenChat}
            isLoading={isLoading}
            handleChangeModalState={handleChangeModalState}
            refundResponse={refundResponse}
            replaceResponse={replaceResponse}
            partialRefundResponse={partialRefundResponse}
            getCurrentPage={getCurrentPage}
            ROSSOrderNumber={ROSSOrderNumber}
            page0ReasonType={page0ReasonType}
            page1ReasonType={page1ReasonType}
            page2ReasonType={page2ReasonType}
            page3ReasonType={page3ReasonType}
            page4ReasonType={page4ReasonType}
            page5ReasonType={page5ReasonType}
            operatingSystem={operatingSystem}
            abcGbmChatPayload={abcGbmChatPayload}
            isShowingMobileChatLink={isShowingMobileChatLink}
        />
    }

    const renderPage7 = () => {
        const { text1, nextPage } = ReplacementHelper.getFoodBrandPageDetails('page7', { page0ReasonType, page7ReasonType });

        return <ReplacementOrderV2Screens
            classes={classes}
            reloadPage={() => history.go()}
            text1={text1}
            handleSelectValue={handleSelectValue}
            handleClickProceed={handleClickProceed}
            handleClickBack={handleClickBack}
            currentPage="page7"
            nextPage={nextPage}
            previousPage="page0"
            btnType="Continue"
            currentSelectedRadio={page7ReasonType}
            handleOpenChat={handleOpenChat}
            isLoading={isLoading}
            handleChangeModalState={handleChangeModalState}
            refundResponse={refundResponse}
            replaceResponse={replaceResponse}
            partialRefundResponse={partialRefundResponse}
            getCurrentPage={getCurrentPage}
            ROSSOrderNumber={ROSSOrderNumber}
            page0ReasonType={page0ReasonType}
            page1ReasonType={page1ReasonType}
            page2ReasonType={page2ReasonType}
            page3ReasonType={page3ReasonType}
            page4ReasonType={page4ReasonType}
            page5ReasonType={page5ReasonType}
            operatingSystem={operatingSystem}
            abcGbmChatPayload={abcGbmChatPayload}
            isShowingMobileChatLink={isShowingMobileChatLink}
        />
    }

    const renderLoadingIcon = () => {
        // full width loader
        if (isLoading && ((!isAvailabilityCheckByPassEnabled && isAvailable === null) || isEmpty(replaceResponse) || isEmpty(partialRefundResponse) || isEmpty(refundResponse))) {
            return (
                <DialogContent className={classes.modalContentContainer}>
                    <div className={classes.loaderContainer}>
                        <CircularProgress color="inherit" size={25} />
                    </div>
                </DialogContent>
            );
        }
        return null;
    }

    return (
        <Dialog fullWidth open maxWidth="sm" name="replacement-modal">
            {renderHeaderComponent(classes)}
            {isLoading && renderLoadingIcon()}
            {
                // fall back to error page if anything goes wrong
                showFallbackScreen ? renderFallbackUI()
                : (
                     <>
                           {page0 ? renderPage0() : null}
                           {page1 ? renderPage1() : null}
                           {page2 ? renderPage2() : null}
                           {page3 ? renderPage3() : null}
                           {page4 ? renderPage4() : null}
                           {page5 ? renderPage5() : null}
                           {page6 ? renderPage6() : null}
                           {page7 ? renderPage7() : null}
                     </>
                  )
            }
        </Dialog>
    )
}

ReplacementOrderModal.defaultProps = {
    refundResponse: {},
    partialRefundResponse: {},
    history: {},
};

ReplacementOrderModal.propTypes = {
    classes: object.isRequired,
    handleChangeModalState: func.isRequired,
    productType: string.isRequired,
    startTime: string.isRequired,
    ROSSOrder: shape({
        brandId: string,
        modifiedDateTime: string,
        orderNumber: string,
        orders: arrayOf(shape({
            actualDeliveryDate: string,
            address: string,
            carrier: string,
            courier: string,
            createdDate: string,
            currentLocation: object,
            deliveryDate: string,
            deliveryImageURL: string,
            deliveryMethod: string,
            deliveryNotes: string,
            history: arrayOf(shape({
                codeStatus: string,
                createdDate: string,
                location: object,
                status: string,
                statusDescription: string,
            })),
            intOrderNumber: string,
        })),
        items: arrayOf(shape({
            productBrand: string,
            itemType: string,
            productName: string,
            productSku: string,
        })),
        origin: string,
        recipientFirstName: string,
        recipientLastName: string,
        signatureImageURL: string,
        status: string,
        statusDescription: string,
        trackingNumber: string,
        type: string,
        warningMessage: string,
    }).isRequired,
    ssrDeviceType: string.isRequired,
    ROSSOrderNumber: string.isRequired,
    history: shape({
        go: func.isRequired,
    }),
    isPartialCreditEnabled: bool.isRequired,
    isReplacementEnabled: bool.isRequired,
    featureFlags: object.isRequired,
};

const mapStateToProps = (state) => {
    return {
        featureFlags: getFeatureFlags(state),
        ssrDeviceType: getSSRDeviceType(state),
    };
};

export default withRouter(connect(mapStateToProps, null)(withStyles(styles)(ReplacementOrderModal)));
